import { apiClient } from '@/lib/api-client';

/**
 * Calls the forgot password API endpoint.
 *
 * @param email - The email address to send the reset link to.
 * @returns A promise that resolves with the API response or rejects with an error.
 */
export async function forgotPassword(email: string) {
  return apiClient.post('/auth/forgot-password', undefined, { query: { email } });
}
